import { render, staticRenderFns } from "./AssessmentReviewDetail.vue?vue&type=template&id=0b331ecd&scoped=true"
import script from "./AssessmentReviewDetail.vue?vue&type=script&lang=js"
export * from "./AssessmentReviewDetail.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReviewDetail.vue?vue&type=style&index=0&id=0b331ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b331ecd",
  null
  
)

export default component.exports